import React from "react";

// ── A ↔ అ swap icon — matches reference image ────────────────────────────────
// viewBox 200×200:
//   "A"    — top-left (large, bold)
//   "అ"    — bottom-right (medium)
//   TOP arc-arrow    — upper-right area, sweeps 3-o'clock → 11-o'clock (CCW), tip ←
//   BOTTOM arc-arrow — lower-left area,  sweeps 9-o'clock →  5-o'clock (CCW), tip →
//   The two arcs form a swap-ring; neither arc overlaps either letter.
const LangSwapIcon: React.FC<{ size?: number }> = ({ size = 36 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    {/* "A" — top-left, large bold */}
    <text
      x="8"
      y="90"
      fontSize="110"
      fontWeight="900"
      fontFamily="Arial Rounded MT Bold, Arial Black, Arial, sans-serif"
      fill="currentColor"
    >
      A
    </text>

    {/* Telugu "అ" — bottom-right */}
    <text
      x="100"
      y="192"
      fontSize="88"
      fontWeight="700"
      fontFamily="Noto Sans Telugu, Mandali, sans-serif"
      fill="currentColor"
    >
      అ
    </text>

    {/* TOP arc-arrow: upper-right, centre ≈ (130,70) r=58
        sweeps from 3-o'clock (182,78) CCW to 11-o'clock (108,18)
        arrowhead at (108,18) pointing ← */}
    <path
      d="M 182 78 A 58 58 0 0 0 108 18"
      stroke="#F5A623"
      strokeWidth="16"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M 124 8 L 106 18 L 120 30"
      stroke="#F5A623"
      strokeWidth="16"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />

    {/* BOTTOM arc-arrow: lower-left, centre ≈ (70,130) r=58
        sweeps from 9-o'clock (18,122) CCW to 5-o'clock (92,182)
        arrowhead at (92,182) pointing → */}
    <path
      d="M 18 122 A 58 58 0 0 0 92 182"
      stroke="#F5A623"
      strokeWidth="16"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M 76 192 L 94 182 L 80 170"
      stroke="#F5A623"
      strokeWidth="16"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default LangSwapIcon;
